export const sizeTypes = {
  small: 'small',
  medium: 'medium',
  large: 'large',
};
export const dataHooks = {
  tag: 'variableinput-tag',
  indicator: 'variableinput-indicator',
};
export const inputToTagsSize = {
  small: 'tiny',
  medium: 'small',
  large: 'medium',
};
export const entityTypes = {
  variable: 'VARIABLE',
};
export const statusTypes = {
  error: 'error',
  warning: 'warning',
};
